// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Global Survey Theme
   Applies only when wrapped in .survey-theme
   ========================================================= */

/* ---------- Page Background ---------- */
.survey-theme.workflow-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #4f6ef7 0%, #5a7bff 100%);
  padding: 48px 24px;
  box-sizing: border-box;
}

/* ---------- Survey Card ---------- */
.survey-theme .workflow-card {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* ---------- Progress Bar ---------- */
.survey-theme .progress-bar {
  height: 6px;
  background: #e5e9ff;
  border-radius: 999px;
  margin-bottom: 24px;
  overflow: hidden;
}

.survey-theme .progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ff9f1c, #ffb347);
  transition: width 0.35s ease;
}

/* ---------- Headings & Copy ---------- */
.survey-theme h1,
.survey-theme h2,
.survey-theme h3 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
}

.survey-theme p {
  font-size: 1.05rem;
  color: #475569;
  margin-bottom: 8px;
}

/* =========================================================
   Inputs
   ========================================================= */

.survey-theme input,
.survey-theme select,
.survey-theme textarea {
  width: 100%;
  padding: 14px 16px;
  font-size: 1rem;
  border-radius: 10px;
  border: 1px solid #c7d2fe;
  margin-top: 12px;
  box-sizing: border-box;
  font-family: inherit;
}

.survey-theme input::placeholder {
  color: #94a3b8;
}

.survey-theme input:focus,
.survey-theme select:focus,
.survey-theme textarea:focus {
  outline: none;
  border-color: #4f6ef7;
  box-shadow: 0 0 0 3px rgba(79, 110, 247, 0.15);
}

/* =========================================================
   Survey Question Table Layout
   ========================================================= */

.survey-question {
  
    width: 90%;
    justify-self: center;
}

.survey-question-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  margin-top: 0px;
}

.survey-help-text {
  margin: 0 0 14px;
  padding: 12px 14px;
  border: 1px solid #d7e7f5;
  border-radius: 14px;
  background: #f3f8fc;
  color: #35556f;
  font-size: 0.96rem;
  line-height: 1.55;
}

.survey-textarea {
  min-height: 142px;
  resize: vertical;
}

/* Options container */
.survey-options-table {
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}

/* Option row */
.survey-option-row {
  display: flex;
    align-items: center;
    gap: 14px;
    padding: 11px 7px;
    cursor: pointer;
    border-bottom: 1px solid #e5e7eb;
    width: 100%;
}

.survey-option-row:last-child {
  border-bottom: none;
}

.survey-option-row:hover {
  background: #f8fafc;
}

.survey-option-row.selected {
  background: #eef2ff;
  box-shadow: inset 0 0 0 1px #4f6ef7;
}

.survey-option-row input {
  margin: 0;
}

.survey-option-label {
  font-size: 1.05rem;
  font-weight: 500;
  color: #0f172a;
}

/* =========================================================
   Content Width Constraint
   ========================================================= */

.survey-question,
.survey-options-table,
.lead-form,
.survey-theme .navigation {
  max-width: 96%;
}

/* =========================================================
   Navigation Buttons (Light Blue, Centered)
   ========================================================= */

.survey-theme .navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
}

/* Base button */
.survey-theme .navigation button {
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  background: #e8f1ff;
  color: #1d4ed8;
  border: 1px solid #c7ddff;
  transition: background 0.2s ease;
}

/* Hover */
.survey-theme .navigation button:hover:not(:disabled) {
  background: #dbeafe;
}

/* Disabled */
.survey-theme .navigation button:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  border-color: #e2e8f0;
  cursor: not-allowed;
}

/* =========================================================
   Mobile Adjustments
   ========================================================= */

@media (max-width: 550px) {
  .survey-question,
  .survey-options-table,
  .lead-form,
  .survey-theme .navigation {
    max-width: 100%;
  }

  .survey-theme .workflow-card {
    padding: 24px;
  }

  .survey-theme h1,
  .survey-theme h2,
  .survey-theme h3 {
    font-size: 1.5rem;
  }

  .survey-theme .navigation {
    flex-direction: column-reverse;
    align-items: center;
  }

  .survey-theme .navigation button {
    width: 100%;
  }
}
/* =========================================================
   SAFETY NET: Ensure survey buttons are styled
   even if .survey-theme wrapper is missing
   ========================================================= */

.workflow-page .navigation button {
  background: #e8f1ff;
  color: #1d4ed8;
  border: 1px solid #c7ddff;
  border-radius: 10px;
  padding: 12px 20px;
  font-weight: 600;
  
}

.workflow-page .navigation button:hover:not(:disabled) {
  background: #dbeafe;
}

.workflow-page .navigation button:disabled {
  background: #f1f5f9;
  color: #94a3b8;
  border-color: #e2e8f0;

}

.navigation {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
}

.survey-page {
  position: relative;
  max-width: 730px;
  min-height: 350px;
  padding: 23px 0px 104px;
}

.survey-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 222px;
  align-items: start;
  gap: 22px;
}

.survey-main {
  min-width: 0;
}

.survey-sidebar {
  position: sticky;
  top: 104px;
}

.survey-card {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  padding: 29px 10px 30px;
  border: 1px solid #dbe4ef;
  border-radius: 28px;
  background:
    radial-gradient(circle at top right, rgba(73, 144, 204, 0.08), transparent 30%),
    linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 22px 56px rgba(18, 47, 76, 0.11);
}

.survey-card::before {
  content: "";
  position: absolute;
  inset: 0 auto auto 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #1d77bd 0%, #6eb3de 100%);
}

.survey-card-header {
  display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 13px;
    width: 93%;
    justify-self: center;
}

.survey-card-title {
  margin: 0;
  color: #0f2740;
  font-size: clamp(2rem, 2.5vw, 2.65rem);
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.survey-card-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.survey-card-title-icon {
  flex: 0 0 auto;
  object-fit: contain;
}

.survey-card-description {
  max-width: 42rem;
  margin: 0;
  color: #5d7186;
  font-size: 1.02rem;
  line-height: 1.6;
}

.survey-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  background: rgba(247, 250, 252, 0.72);
  backdrop-filter: blur(2px);
}

.survey-spinner {
  width: 52px;
  height: 52px;
  border: 4px solid rgba(29, 119, 189, 0.16);
  border-top-color: #1d77bd;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.survey-content.is-hidden,
.response-hidden {
  visibility: hidden;
  pointer-events: none;
}

.lead-form-wrapper {
  max-width: none;
  margin: 0;
}

.survey-options-table.lead-form-layout {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.lead-form-intro {
  margin-bottom: 22px;
}

.lead-form-intro p {
  margin: 0;
  color: #6a7f92;
  font-size: 0.98rem;
  line-height: 1.6;
}

.lead-form-columns {
  display: block;
}

.lead-form-left {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 18px 14px;
}

.lead-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.lead-field-full {
  grid-column: span 12;
}

.lead-field-half {
  grid-column: span 6;
}

.lead-field-city {
  grid-column: span 5;
}

.lead-field-state {
  grid-column: span 3;
}

.lead-field-zip {
  grid-column: span 4;
}

.lead-form-label {
  display: block;
  margin: 0;
  color: #27435f;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.lead-form-control,
.lead-form input,
.lead-form select,
.text-input {
  width: 100%;
  min-width: 0;
  height: 56px;
  padding: 0 16px;
  border: 1px solid #cfdae5;
  border-radius: 16px;
  background: #f9fbfd;
  color: #11263d;
  font-size: 1rem;
  line-height: 1.4;
  box-sizing: border-box;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, transform 0.18s ease;
}

.lead-form-control::placeholder,
.lead-form input::placeholder,
.text-input::placeholder {
  color: #90a2b3;
}

.lead-form-control:hover,
.lead-form input:hover,
.lead-form select:hover,
.text-input:hover {
  border-color: #b4c7d9;
  background: #ffffff;
}

.lead-form-control:focus,
.lead-form input:focus,
.lead-form select:focus,
.text-input:focus {
  outline: none;
  border-color: #1d77bd;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(29, 119, 189, 0.12);
  transform: translateY(-1px);
}

.lead-form-control:invalid,
.lead-form input:invalid,
.lead-form select:invalid {
  border-color: #dc2626;
}

.lead-form-thumbnails {
  grid-column: span 12;
  margin-top: 6px;
  padding-top: 6px;
}

.lead-form-thumbnails-label {
  margin: 0 0 10px;
  color: #5f7388;
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.lead-form-consent {
  grid-column: span 12;
  margin-top: 8px;
  padding: 16px 18px;
  border: 1px solid #d7e2ec;
  border-radius: 18px;
  background: #f8fbfe;
}

.lead-form-consent-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
}

.lead-form-consent-row input {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  margin: 2px 0 0;
}

.lead-form-consent-copy {
  color: #35506a;
  font-size: 0.84rem;
  line-height: 1.6;
}

.lead-form-consent-copy a {
  color: #1d77bd;
  font-weight: 700;
  text-decoration: underline;
}

.uploaded-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(76px, 92px));
  gap: 10px;
  justify-content: start;
  justify-items: start;
}

.uploaded-grid-item {
  width: 100%;
  max-width: 96px;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid #dde7ef;
  background: #eef5fb;
  box-shadow: 0 6px 16px rgba(15, 39, 64, 0.08);
}

.uploaded-grid img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 1;
  background: #eef5fb;
}

.upload-card {
      max-width: 649px;
    margin: 0 auto;
    padding: 14px 7px 1px 15px;
    background: #fff;
    border-radius: 20px;
    border: 1px solid #dce6f0;
    box-shadow: 0 16px 40px rgba(18, 47, 76, 0.09);
}

.upload-help,
.field-hint,
.upload-count {
  color: #5f7388;
}

.upload-help {
  font-size: 0.98rem;
  line-height: 1.6;
}

.upload-controls,
.upload-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.upload-actions {
  margin-top: 18px;
}

.btn,
.survey-back-button,
.survey-next-button {
  min-height: 54px;
  padding: 0 22px;
  border-radius: 15px;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.btn-primary,
.survey-next-button {
  border: none;
  background: linear-gradient(135deg, #1d77bd 0%, #2f93d8 100%);
  color: #ffffff;
  box-shadow: 0 16px 30px rgba(29, 119, 189, 0.23);
}

.btn-primary:hover,
.survey-next-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 20px 34px rgba(29, 119, 189, 0.27);
}

.btn-secondary,
.btn-outline,
.survey-back-button {
  border: 1px solid #cbd8e4;
  background: #ffffff;
  color: #27435f;
  box-shadow: none;
}

.btn-secondary:hover,
.btn-outline:hover,
.survey-back-button:hover:not(:disabled) {
  border-color: #aac2d7;
  background: #f7fafc;
}

.survey-actions {
      display: flex;
    align-items: center;
    gap: 14px;
    margin-top: 16px;
    width: 85%;
    justify-self: center;
}

.survey-next-button {
  flex: 1;
  justify-content: center;
}

.survey-back-button {
  flex: 0 0 auto;
}

.survey-next-button:disabled,
.survey-back-button:disabled,
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.survey-next-button:focus-visible,
.survey-back-button:focus-visible,
.featured-cta:focus-visible,
.btn:focus-visible {
  outline: 3px solid rgba(29, 119, 189, 0.24);
  outline-offset: 3px;
}

.form-error,
.survey-validation-error {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid #f4c7c7;
  border-radius: 14px;
  background: #fff5f5;
  color: #b42318;
  font-size: 0.95rem;
  font-weight: 700;
  text-align: left;
}

.survey-trust-copy {
  margin: 14px 4px 0;
  color: #66798d;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;
}

.featured-cta {
  display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 15px 20px;
    border: 1px solid #d9e5ef;
    border-radius: 22px;
    background: #ffffff;
    box-shadow: 0 12px 31px rgba(15, 39, 64, 0.04);
    cursor: pointer;
    width: 222px;
}

.featured-cta-badge {
  align-self: flex-start;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef6fc;
  color: #1d77bd;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.featured-cta-media {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  padding: 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #f7fafc 0%, #eef5fb 100%);
  border: 1px solid #e2ebf2;
}

.featured-cta img {
  width: 100%;
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
  object-position: center;
}

.featured-cta-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.featured-cta-eyebrow {
  margin: 0;
  color: #7290ab;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.featured-cta h3 {
  margin: 0;
  color: #17324e;
  font-size: 1.15rem;
  line-height: 1.3;
}

.featured-cta-copy {
  margin: 0;
  color: #5f7388;
  font-size: 0.95rem;
  line-height: 1.6;
}

.featured-cta-link {
  display: inline-flex;
  align-self: flex-start;
  margin-top: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1d77bd;
  font-size: 0.92rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

.featured-cta-link:hover {
  text-decoration: underline;
}

.featured-cta-disclaimer {
  margin: 2px 0 0;
  color: #98a6b6;
  font-size: 0.78rem;
  line-height: 1.4;
}

.mobile-featured {
  display: none;
  margin-top: 22px;
}

@media (max-width: 550px) {
  .survey-page {
    padding: 10px 14px 39px;
  }

  .survey-main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .survey-layout {
    grid-template-columns: minmax(0, 1fr);
    gap: 24px;
  }

  .survey-sidebar {
    display: none;
  }

  .mobile-featured {
    display: block;
    order: -1;
    width: 90%;
    margin: 0 auto 11px;
  }

  .survey-card {
    padding: 24px 16px 20px;
    border-radius: 22px;
    width: 100%;
  }

  .survey-card-title {
    font-size: 1.8rem;
  }

  .survey-card-title-row {
    gap: 8px;
  }

  .final-step-header {
             font-size: 24px;
        margin-left: 22px;
        justify-self: left;
  }

  .lead-form-left {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .lead-field-full,
  .lead-field-half,
  .lead-field-city,
  .lead-field-state,
  .lead-field-zip {
    grid-column: span 1;
  }

  .lead-form-field {
    gap: 6px;
  }

  .lead-form-label {
    font-size: 0.96rem;
  }

  .lead-form-control,
  .lead-form input,
  .lead-form select,
  .text-input,
  .btn,
  .survey-back-button,
  .survey-next-button {
    min-height: 52px;
  }

  .lead-form-thumbnails {
    margin-top: 2px;
    padding-top: 0;
  }

  .lead-form-consent {
    margin-top: 4px;
    padding: 14px;
  }

  .lead-form-consent-copy {
    font-size: 0.9rem;
  }

  .uploaded-grid {
    grid-template-columns: repeat(2, minmax(0, 104px));
    gap: 12px;
  }

  .uploaded-grid-item {
    max-width: none;
  }

  .featured-cta {
             width: 100%;
        max-width: none;
        min-height: 73px;
        max-height: 78px;
        flex-direction: row;
        align-items: center;
        gap: 6px;
        padding: 11px 9px;
        border-radius: 18px;
        overflow: hidden;
  }

  .featured-cta-badge,
  .featured-cta-copy,
  .featured-cta-disclaimer {
    display: none;
  }

  .featured-cta-media {
    flex: 0 0 66px;
    width: 66px;
    /* min-height: 74px; */
    height: 61px;
    padding: 4px;
    border-radius: 14px;
  }

  .featured-cta img {
    max-height: 58px;
  }

  .featured-cta-body {
    flex: 1;
    min-width: 0;
    gap: 4px;
  }

  .featured-cta-eyebrow {
    font-size: 0.68rem;
  }

  .featured-cta h3 {
    font-size: 1rem;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .featured-cta-link {
    margin-top: 0;
    font-size: 0.84rem;
  }

  .survey-actions {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 12px;
  }

  .survey-back-button,
  .survey-next-button {
    width: 100%;
  }

  .survey-back-button {
    flex: 0 0 auto;
  }

  .survey-next-button {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/survey.css"],"names":[],"mappings":"AAAA;;;8DAG8D;;AAE9D,0CAA0C;AAC1C;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA,0CAA0C;AAC1C;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;8DAE8D;;AAE9D;;;EAGE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;8DAE8D;;AAE9D;;IAEI,UAAU;IACV,oBAAoB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;IACX,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,WAAW;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;;;;EAIE,cAAc;AAChB;;AAEA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;8DAE8D;;AAE9D;EACE;;;;IAIE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;AACA;;;8DAG8D;;AAE9D;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;;AAElB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;;AAEvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB;;qDAEmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,aAAa;IACX,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6GAA6G;AAC/G;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;;EAIE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;MACM,gBAAgB;IAClB,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+HAA+H;AACjI;;AAEA;;EAEE,YAAY;EACZ,6DAA6D;EAC7D,cAAc;EACd,gDAAgD;AAClD;;AAEA;;EAEE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;MACM,aAAa;IACf,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,oBAAoB;AACxB;;AAEA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;IACX,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;IAC9C,eAAe;IACf,YAAY;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,SAAS;IACT,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;aACW,eAAe;QACpB,iBAAiB;QACjB,kBAAkB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;;;IAKE,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;;;;IAOE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kDAAkD;IAClD,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;aACW,WAAW;QAChB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,QAAQ;QACR,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;EACtB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* =========================================================\n   Global Survey Theme\n   Applies only when wrapped in .survey-theme\n   ========================================================= */\n\n/* ---------- Page Background ---------- */\n.survey-theme.workflow-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #4f6ef7 0%, #5a7bff 100%);\n  padding: 48px 24px;\n  box-sizing: border-box;\n}\n\n/* ---------- Survey Card ---------- */\n.survey-theme .workflow-card {\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n/* ---------- Progress Bar ---------- */\n.survey-theme .progress-bar {\n  height: 6px;\n  background: #e5e9ff;\n  border-radius: 999px;\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.survey-theme .progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #ff9f1c, #ffb347);\n  transition: width 0.35s ease;\n}\n\n/* ---------- Headings & Copy ---------- */\n.survey-theme h1,\n.survey-theme h2,\n.survey-theme h3 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 12px;\n}\n\n.survey-theme p {\n  font-size: 1.05rem;\n  color: #475569;\n  margin-bottom: 8px;\n}\n\n/* =========================================================\n   Inputs\n   ========================================================= */\n\n.survey-theme input,\n.survey-theme select,\n.survey-theme textarea {\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 1rem;\n  border-radius: 10px;\n  border: 1px solid #c7d2fe;\n  margin-top: 12px;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.survey-theme input::placeholder {\n  color: #94a3b8;\n}\n\n.survey-theme input:focus,\n.survey-theme select:focus,\n.survey-theme textarea:focus {\n  outline: none;\n  border-color: #4f6ef7;\n  box-shadow: 0 0 0 3px rgba(79, 110, 247, 0.15);\n}\n\n/* =========================================================\n   Survey Question Table Layout\n   ========================================================= */\n\n.survey-question {\n  \n    width: 90%;\n    justify-self: center;\n}\n\n.survey-question-title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-top: 0px;\n}\n\n.survey-help-text {\n  margin: 0 0 14px;\n  padding: 12px 14px;\n  border: 1px solid #d7e7f5;\n  border-radius: 14px;\n  background: #f3f8fc;\n  color: #35556f;\n  font-size: 0.96rem;\n  line-height: 1.55;\n}\n\n.survey-textarea {\n  min-height: 142px;\n  resize: vertical;\n}\n\n/* Options container */\n.survey-options-table {\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n/* Option row */\n.survey-option-row {\n  display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 11px 7px;\n    cursor: pointer;\n    border-bottom: 1px solid #e5e7eb;\n    width: 100%;\n}\n\n.survey-option-row:last-child {\n  border-bottom: none;\n}\n\n.survey-option-row:hover {\n  background: #f8fafc;\n}\n\n.survey-option-row.selected {\n  background: #eef2ff;\n  box-shadow: inset 0 0 0 1px #4f6ef7;\n}\n\n.survey-option-row input {\n  margin: 0;\n}\n\n.survey-option-label {\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n/* =========================================================\n   Content Width Constraint\n   ========================================================= */\n\n.survey-question,\n.survey-options-table,\n.lead-form,\n.survey-theme .navigation {\n  max-width: 96%;\n}\n\n/* =========================================================\n   Navigation Buttons (Light Blue, Centered)\n   ========================================================= */\n\n.survey-theme .navigation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n/* Base button */\n.survey-theme .navigation button {\n  border-radius: 10px;\n  padding: 12px 20px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  background: #e8f1ff;\n  color: #1d4ed8;\n  border: 1px solid #c7ddff;\n  transition: background 0.2s ease;\n}\n\n/* Hover */\n.survey-theme .navigation button:hover:not(:disabled) {\n  background: #dbeafe;\n}\n\n/* Disabled */\n.survey-theme .navigation button:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  border-color: #e2e8f0;\n  cursor: not-allowed;\n}\n\n/* =========================================================\n   Mobile Adjustments\n   ========================================================= */\n\n@media (max-width: 550px) {\n  .survey-question,\n  .survey-options-table,\n  .lead-form,\n  .survey-theme .navigation {\n    max-width: 100%;\n  }\n\n  .survey-theme .workflow-card {\n    padding: 24px;\n  }\n\n  .survey-theme h1,\n  .survey-theme h2,\n  .survey-theme h3 {\n    font-size: 1.5rem;\n  }\n\n  .survey-theme .navigation {\n    flex-direction: column-reverse;\n    align-items: center;\n  }\n\n  .survey-theme .navigation button {\n    width: 100%;\n  }\n}\n/* =========================================================\n   SAFETY NET: Ensure survey buttons are styled\n   even if .survey-theme wrapper is missing\n   ========================================================= */\n\n.workflow-page .navigation button {\n  background: #e8f1ff;\n  color: #1d4ed8;\n  border: 1px solid #c7ddff;\n  border-radius: 10px;\n  padding: 12px 20px;\n  font-weight: 600;\n  \n}\n\n.workflow-page .navigation button:hover:not(:disabled) {\n  background: #dbeafe;\n}\n\n.workflow-page .navigation button:disabled {\n  background: #f1f5f9;\n  color: #94a3b8;\n  border-color: #e2e8f0;\n\n}\n\n.navigation {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n    margin-top: 24px;\n}\n\n.survey-page {\n  position: relative;\n  max-width: 730px;\n  min-height: 350px;\n  padding: 23px 0px 104px;\n}\n\n.survey-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 222px;\n  align-items: start;\n  gap: 22px;\n}\n\n.survey-main {\n  min-width: 0;\n}\n\n.survey-sidebar {\n  position: sticky;\n  top: 104px;\n}\n\n.survey-card {\n  position: relative;\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 29px 10px 30px;\n  border: 1px solid #dbe4ef;\n  border-radius: 28px;\n  background:\n    radial-gradient(circle at top right, rgba(73, 144, 204, 0.08), transparent 30%),\n    linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  box-shadow: 0 22px 56px rgba(18, 47, 76, 0.11);\n}\n\n.survey-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto auto 0;\n  width: 100%;\n  height: 5px;\n  background: linear-gradient(90deg, #1d77bd 0%, #6eb3de 100%);\n}\n\n.survey-card-header {\n  display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 13px;\n    width: 93%;\n    justify-self: center;\n}\n\n.survey-card-title {\n  margin: 0;\n  color: #0f2740;\n  font-size: clamp(2rem, 2.5vw, 2.65rem);\n  line-height: 1.05;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n}\n\n.survey-card-title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.survey-card-title-icon {\n  flex: 0 0 auto;\n  object-fit: contain;\n}\n\n.survey-card-description {\n  max-width: 42rem;\n  margin: 0;\n  color: #5d7186;\n  font-size: 1.02rem;\n  line-height: 1.6;\n}\n\n.survey-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  background: rgba(247, 250, 252, 0.72);\n  backdrop-filter: blur(2px);\n}\n\n.survey-spinner {\n  width: 52px;\n  height: 52px;\n  border: 4px solid rgba(29, 119, 189, 0.16);\n  border-top-color: #1d77bd;\n  border-radius: 50%;\n  animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.survey-content.is-hidden,\n.response-hidden {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.lead-form-wrapper {\n  max-width: none;\n  margin: 0;\n}\n\n.survey-options-table.lead-form-layout {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.lead-form-intro {\n  margin-bottom: 22px;\n}\n\n.lead-form-intro p {\n  margin: 0;\n  color: #6a7f92;\n  font-size: 0.98rem;\n  line-height: 1.6;\n}\n\n.lead-form-columns {\n  display: block;\n}\n\n.lead-form-left {\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n  gap: 18px 14px;\n}\n\n.lead-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.lead-field-full {\n  grid-column: span 12;\n}\n\n.lead-field-half {\n  grid-column: span 6;\n}\n\n.lead-field-city {\n  grid-column: span 5;\n}\n\n.lead-field-state {\n  grid-column: span 3;\n}\n\n.lead-field-zip {\n  grid-column: span 4;\n}\n\n.lead-form-label {\n  display: block;\n  margin: 0;\n  color: #27435f;\n  font-size: 0.92rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.lead-form-control,\n.lead-form input,\n.lead-form select,\n.text-input {\n  width: 100%;\n  min-width: 0;\n  height: 56px;\n  padding: 0 16px;\n  border: 1px solid #cfdae5;\n  border-radius: 16px;\n  background: #f9fbfd;\n  color: #11263d;\n  font-size: 1rem;\n  line-height: 1.4;\n  box-sizing: border-box;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, transform 0.18s ease;\n}\n\n.lead-form-control::placeholder,\n.lead-form input::placeholder,\n.text-input::placeholder {\n  color: #90a2b3;\n}\n\n.lead-form-control:hover,\n.lead-form input:hover,\n.lead-form select:hover,\n.text-input:hover {\n  border-color: #b4c7d9;\n  background: #ffffff;\n}\n\n.lead-form-control:focus,\n.lead-form input:focus,\n.lead-form select:focus,\n.text-input:focus {\n  outline: none;\n  border-color: #1d77bd;\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(29, 119, 189, 0.12);\n  transform: translateY(-1px);\n}\n\n.lead-form-control:invalid,\n.lead-form input:invalid,\n.lead-form select:invalid {\n  border-color: #dc2626;\n}\n\n.lead-form-thumbnails {\n  grid-column: span 12;\n  margin-top: 6px;\n  padding-top: 6px;\n}\n\n.lead-form-thumbnails-label {\n  margin: 0 0 10px;\n  color: #5f7388;\n  font-size: 0.88rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.lead-form-consent {\n  grid-column: span 12;\n  margin-top: 8px;\n  padding: 16px 18px;\n  border: 1px solid #d7e2ec;\n  border-radius: 18px;\n  background: #f8fbfe;\n}\n\n.lead-form-consent-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.lead-form-consent-row input {\n  flex: 0 0 auto;\n  width: 18px;\n  height: 18px;\n  margin: 2px 0 0;\n}\n\n.lead-form-consent-copy {\n  color: #35506a;\n  font-size: 0.84rem;\n  line-height: 1.6;\n}\n\n.lead-form-consent-copy a {\n  color: #1d77bd;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.uploaded-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(76px, 92px));\n  gap: 10px;\n  justify-content: start;\n  justify-items: start;\n}\n\n.uploaded-grid-item {\n  width: 100%;\n  max-width: 96px;\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n  border-radius: 14px;\n  border: 1px solid #dde7ef;\n  background: #eef5fb;\n  box-shadow: 0 6px 16px rgba(15, 39, 64, 0.08);\n}\n\n.uploaded-grid img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  opacity: 1;\n  background: #eef5fb;\n}\n\n.upload-card {\n      max-width: 649px;\n    margin: 0 auto;\n    padding: 14px 7px 1px 15px;\n    background: #fff;\n    border-radius: 20px;\n    border: 1px solid #dce6f0;\n    box-shadow: 0 16px 40px rgba(18, 47, 76, 0.09);\n}\n\n.upload-help,\n.field-hint,\n.upload-count {\n  color: #5f7388;\n}\n\n.upload-help {\n  font-size: 0.98rem;\n  line-height: 1.6;\n}\n\n.upload-controls,\n.upload-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.upload-actions {\n  margin-top: 18px;\n}\n\n.btn,\n.survey-back-button,\n.survey-next-button {\n  min-height: 54px;\n  padding: 0 22px;\n  border-radius: 15px;\n  font-size: 0.98rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n\n.btn-primary,\n.survey-next-button {\n  border: none;\n  background: linear-gradient(135deg, #1d77bd 0%, #2f93d8 100%);\n  color: #ffffff;\n  box-shadow: 0 16px 30px rgba(29, 119, 189, 0.23);\n}\n\n.btn-primary:hover,\n.survey-next-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 20px 34px rgba(29, 119, 189, 0.27);\n}\n\n.btn-secondary,\n.btn-outline,\n.survey-back-button {\n  border: 1px solid #cbd8e4;\n  background: #ffffff;\n  color: #27435f;\n  box-shadow: none;\n}\n\n.btn-secondary:hover,\n.btn-outline:hover,\n.survey-back-button:hover:not(:disabled) {\n  border-color: #aac2d7;\n  background: #f7fafc;\n}\n\n.survey-actions {\n      display: flex;\n    align-items: center;\n    gap: 14px;\n    margin-top: 16px;\n    width: 85%;\n    justify-self: center;\n}\n\n.survey-next-button {\n  flex: 1;\n  justify-content: center;\n}\n\n.survey-back-button {\n  flex: 0 0 auto;\n}\n\n.survey-next-button:disabled,\n.survey-back-button:disabled,\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.survey-next-button:focus-visible,\n.survey-back-button:focus-visible,\n.featured-cta:focus-visible,\n.btn:focus-visible {\n  outline: 3px solid rgba(29, 119, 189, 0.24);\n  outline-offset: 3px;\n}\n\n.form-error,\n.survey-validation-error {\n  margin-top: 18px;\n  padding: 14px 16px;\n  border: 1px solid #f4c7c7;\n  border-radius: 14px;\n  background: #fff5f5;\n  color: #b42318;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-align: left;\n}\n\n.survey-trust-copy {\n  margin: 14px 4px 0;\n  color: #66798d;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  text-align: center;\n}\n\n.featured-cta {\n  display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 15px 20px;\n    border: 1px solid #d9e5ef;\n    border-radius: 22px;\n    background: #ffffff;\n    box-shadow: 0 12px 31px rgba(15, 39, 64, 0.04);\n    cursor: pointer;\n    width: 222px;\n}\n\n.featured-cta-badge {\n  align-self: flex-start;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #1d77bd;\n  font-size: 0.76rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.featured-cta-media {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60px;\n  padding: 16px;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #f7fafc 0%, #eef5fb 100%);\n  border: 1px solid #e2ebf2;\n}\n\n.featured-cta img {\n  width: 100%;\n  max-width: 100%;\n  max-height: 150px;\n  object-fit: contain;\n  object-position: center;\n}\n\n.featured-cta-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.featured-cta-eyebrow {\n  margin: 0;\n  color: #7290ab;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.featured-cta h3 {\n  margin: 0;\n  color: #17324e;\n  font-size: 1.15rem;\n  line-height: 1.3;\n}\n\n.featured-cta-copy {\n  margin: 0;\n  color: #5f7388;\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n.featured-cta-link {\n  display: inline-flex;\n  align-self: flex-start;\n  margin-top: 2px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1d77bd;\n  font-size: 0.92rem;\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.featured-cta-link:hover {\n  text-decoration: underline;\n}\n\n.featured-cta-disclaimer {\n  margin: 2px 0 0;\n  color: #98a6b6;\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n.mobile-featured {\n  display: none;\n  margin-top: 22px;\n}\n\n@media (max-width: 550px) {\n  .survey-page {\n    padding: 10px 14px 39px;\n  }\n\n  .survey-main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .survey-layout {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 24px;\n  }\n\n  .survey-sidebar {\n    display: none;\n  }\n\n  .mobile-featured {\n    display: block;\n    order: -1;\n    width: 90%;\n    margin: 0 auto 11px;\n  }\n\n  .survey-card {\n    padding: 24px 16px 20px;\n    border-radius: 22px;\n    width: 100%;\n  }\n\n  .survey-card-title {\n    font-size: 1.8rem;\n  }\n\n  .survey-card-title-row {\n    gap: 8px;\n  }\n\n  .final-step-header {\n             font-size: 24px;\n        margin-left: 22px;\n        justify-self: left;\n  }\n\n  .lead-form-left {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n  }\n\n  .lead-field-full,\n  .lead-field-half,\n  .lead-field-city,\n  .lead-field-state,\n  .lead-field-zip {\n    grid-column: span 1;\n  }\n\n  .lead-form-field {\n    gap: 6px;\n  }\n\n  .lead-form-label {\n    font-size: 0.96rem;\n  }\n\n  .lead-form-control,\n  .lead-form input,\n  .lead-form select,\n  .text-input,\n  .btn,\n  .survey-back-button,\n  .survey-next-button {\n    min-height: 52px;\n  }\n\n  .lead-form-thumbnails {\n    margin-top: 2px;\n    padding-top: 0;\n  }\n\n  .lead-form-consent {\n    margin-top: 4px;\n    padding: 14px;\n  }\n\n  .lead-form-consent-copy {\n    font-size: 0.9rem;\n  }\n\n  .uploaded-grid {\n    grid-template-columns: repeat(2, minmax(0, 104px));\n    gap: 12px;\n  }\n\n  .uploaded-grid-item {\n    max-width: none;\n  }\n\n  .featured-cta {\n             width: 100%;\n        max-width: none;\n        min-height: 73px;\n        max-height: 78px;\n        flex-direction: row;\n        align-items: center;\n        gap: 6px;\n        padding: 11px 9px;\n        border-radius: 18px;\n        overflow: hidden;\n  }\n\n  .featured-cta-badge,\n  .featured-cta-copy,\n  .featured-cta-disclaimer {\n    display: none;\n  }\n\n  .featured-cta-media {\n    flex: 0 0 66px;\n    width: 66px;\n    /* min-height: 74px; */\n    height: 61px;\n    padding: 4px;\n    border-radius: 14px;\n  }\n\n  .featured-cta img {\n    max-height: 58px;\n  }\n\n  .featured-cta-body {\n    flex: 1;\n    min-width: 0;\n    gap: 4px;\n  }\n\n  .featured-cta-eyebrow {\n    font-size: 0.68rem;\n  }\n\n  .featured-cta h3 {\n    font-size: 1rem;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .featured-cta-link {\n    margin-top: 0;\n    font-size: 0.84rem;\n  }\n\n  .survey-actions {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    gap: 12px;\n  }\n\n  .survey-back-button,\n  .survey-next-button {\n    width: 100%;\n  }\n\n  .survey-back-button {\n    flex: 0 0 auto;\n  }\n\n  .survey-next-button {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
